import Vue from 'vue'
import Router from 'vue-router'
import firebase from 'firebase'

// Main landing page (when unauthenticated)
import LandingPage from '@/components/LandingPage'

// User state components (User/*)
import Login from '@/components/User/Login'
import SignUp from '@/components/User/SignUp'
import Profile from '@/components/User/Profile'
import ResetPassword from '@/components/User/ResetPassword'
import ResetPasswordConfirmation from '@/components/User/ResetPasswordConfirmation'
import VerifyEmail from '@/components/User/VerifyEmail'
import ForgotPassword from '@/components/User/ForgotPassword'
import ConfirmLogin from '@/components/User/ConfirmLogin'

// User on-boarding tour components (Tour/*)
import Tour from '@/components/Tour/Tour'
import Tour1 from '@/components/Tour/Tour1'
import Tour2 from '@/components/Tour/Tour2'
import Tour3 from '@/components/Tour/Tour3'
import Tour4 from '@/components/Tour/Tour4'
import Tour5 from '@/components/Tour/Tour5'
import Tour6 from '@/components/Tour/Tour6'

// Dynamic (API-driven) Challenge components
// import Leaderboard from '@/components/Challenge/Leaderboard'  // after deadline, switch to the one below
// import Leaderboard from '@/components/Challenge/LeaderboardUnderEval'
import Submissions from '@/components/Challenge/Submissions'
// import Submit from '@/components/Challenge/Submit'
import SubmissionConfirmed from '@/components/Challenge/SubmissionConfirmed'
import DownloadLinks from '@/components/Challenge/DownloadLinks'

// Content-based Challenge components
import Challenge from '@/components/Challenge/Challenge'
import ChallengeAwards from '@/components/Challenge/ChallengeAwards'
import Data from '@/components/Challenge/Data'
import DataDownload from '@/components/Challenge/DataDownload'
import Baseline from '@/components/Challenge/Baseline'
import Rules from '@/components/Challenge/Rules'
import Errors from '@/components/Challenge/Errors'
import Tutorial from '@/components/Challenge/Tutorial'
import Faq from '@/components/Challenge/Faq'
import ExternalResources from '@/components/Challenge/ExternalResources'
import Discussion from '@/components/Discussion'

// Terms (Terms/)
import UserTerms from '@/components/Terms/UserTerms'
import DataTerms from '@/components/Terms/DataTerms'
import SubmissionTerms from '@/components/Terms/SubmissionTerms'
import FinalSubmissionTerms from '@/components/Terms/FinalSubmissionTerms'

import RoutingError from '@/components/RoutingError'
import DisabledFeature from '@/components/DisabledFeature'

Vue.use(Router)

let router = new Router({
  mode: 'history',
  routes: [
    {
      path: '*',
      redirect: '/routing-error'
    },

    {
      path: '/',
      redirect: '/welcome'
    },

    {
      path: '/routing-error',
      name: 'RoutingError',
      component: RoutingError,
      meta: {
        requiresAuth: false,
        requiresVerifiedEmail: false
      }
    },

    {
      path: '/welcome',
      name: 'LandingPage',
      component: LandingPage,
      meta: {
        requiresAuth: false,
        requiresVerifiedEmail: false
      }
    },

    {
      path: '/verify-email',
      name: 'VerifyEmail',
      component: VerifyEmail,
      meta: {
        requiresAuth: true,
        requiresVerifiedEmail: false
      }
    },

    {
      path: '/login',
      name: 'Login',
      component: Login,
      meta: {
        requiresAuth: false,
        requiresVerifiedEmail: false
      }
    },

    {
      path: '/confirm-login',
      name: 'ConfirmLogin',
      component: ConfirmLogin,
      meta: {
        requiresAuth: true,
        requiresVerifiedEmail: false
      }
    },

    {
      path: '/signup',
      name: 'SignUp',
      component: SignUp,
      meta: {
        requiresAuth: false,
        requiresVerifiedEmail: false
      }
    },

    {
      path: '/forgot-password',
      name: 'ForgotPassword',
      component: ForgotPassword,
      meta: {
        requiresAuth: false,
        requiresVerifiedEmail: false
      }
    },

    {
      path: '/reset-password',
      name: 'ResetPassword',
      component: ResetPassword,
      meta: {
        requiresAuth: false,
        requiresVerifiedEmail: false
      }
    },

    {
      path: '/reset-password-confirmation',
      name: 'ResetPasswordConfirmation',
      component: ResetPasswordConfirmation,
      meta: {
        requiresAuth: false,
        requiresVerifiedEmail: false
      }
    },

    {
      path: '/challenge',
      name: 'Challenge',
      component: Challenge,
      meta: {
        requiresAuth: false,
        requiresVerifiedEmail: false
      }
    },

    {
      path: '/challenge-description',
      name: 'ChallengeDescription',
      component: Challenge,
      meta: {
        requiresAuth: false,
        requiresVerifiedEmail: false
      },
      props: { default: true, activeTab: 'description' }
    },

    {
      path: '/challenge-evaluation',
      name: 'ChallengeEvaluation',
      component: Challenge,
      meta: {
        requiresAuth: false,
        requiresVerifiedEmail: false
      },
      props: { default: true, activeTab: 'evaluation' }
    },

    {
      path: '/challenge-awards',
      name: 'ChallengeAwards',
      component: Challenge,
      meta: {
        requiresAuth: false,
        requiresVerifiedEmail: false
      },
      props: { default: true, activeTab: 'awards' }
    },

    {
      path: '/awards',
      name: 'ChallengeAwardsDirect',
      component: ChallengeAwards,
      meta: {
        requiresAuth: false,
        requiresVerifiedEmail: false
      }
    },

    // {
    //   path: '/challenge-timeline',
    //   name: 'ChallengeTimeline',
    //   component: Challenge,
    //   meta: {
    //     requiresAuth: false,
    //     requiresVerifiedEmail: false
    //   },
    //   props: { default: true, activeTab: 'timeline' }
    // },

    // {
    //   path: '/challenge-description',
    //   name: 'ChallengeDescription',
    //   component: ChallengeDescription,
    //   meta: {
    //     requiresAuth: false,
    //     requiresVerifiedEmail: false
    //   }
    // },

    // {
    //   path: '/challenge-evaluation',
    //   name: 'ChallengeEvaluation',
    //   component: ChallengeEvaluation,
    //   meta: {
    //     requiresAuth: false,
    //     requiresVerifiedEmail: false
    //   }
    // },

    // {
    //   path: '/challenge-awards',
    //   name: 'ChallengeAwards',
    //   component: ChallengeAwards,
    //   meta: {
    //     requiresAuth: false,
    //     requiresVerifiedEmail: false
    //   }
    // },

    // {
    //   path: '/challenge-submission-format',
    //   name: 'ChallengeSubmissionFormat',
    //   component: ChallengeSubmissionFormat,
    //   meta: {
    //     requiresAuth: false,
    //     requiresVerifiedEmail: false
    //   }
    // },

    {
      path: '/submit',
      name: 'Submit',
      // component: Submit,
      component: DisabledFeature,
      meta: {
        requiresAuth: true,
        requiresVerifiedEmail: true
      }
    },

    {
      path: '/data-explore',
      name: 'DataExplore',
      component: Data,
      meta: {
        requiresAuth: true,
        requiresVerifiedEmail: true
      },
      props: { default: true, activeTab: 'explore' }
    },

    {
      path: '/data-format',
      name: 'DataFormat',
      component: Data,
      meta: {
        requiresAuth: true,
        requiresVerifiedEmail: true
      },
      props: { default: true, activeTab: 'format' }
    },

    {
      path: '/data-download',
      name: 'DataDownload',
      component: Data,
      meta: {
        requiresAuth: true,
        requiresVerifiedEmail: true
      },
      props: { default: true, activeTab: 'download' }
    },

    {
      path: '/data-download-direct',
      name: 'DataDownloadDirect',
      component: DataDownload,
      meta: {
        requiresAuth: true,
        requiresVerifiedEmail: true
      }
    },

    // {
    //   path: '/data-explore',
    //   name: 'DataExplore',
    //   component: DataExplore,
    //   meta: {
    //     requiresAuth: false,
    //     requiresVerifiedEmail: false
    //   }
    // },

    // {
    //   path: '/data-format',
    //   name: 'DataFormat',
    //   component: DataFormat,
    //   meta: {
    //     requiresAuth: true,
    //     requiresVerifiedEmail: true
    //   }
    // },

    // {
    //   path: '/data-download',
    //   name: 'DataDownload',
    //   component: DataDownload,
    //   meta: {
    //     requiresAuth: true,
    //     requiresVerifiedEmail: true
    //   }
    // },

    {
      path: '/download-links',
      name: 'DownloadLinks',
      component: DownloadLinks,
      meta: {
        requiresAuth: true,
        requiresVerifiedEmail: true
      }
    },

    {
      path: '/baseline',
      name: 'Baseline',
      component: Baseline,
      meta: {
        requiresAuth: true,
        requiresVerifiedEmail: true
      }
    },

    {
      path: '/tutorial',
      name: 'Tutorial',
      component: Tutorial,
      meta: {
        requiresAuth: true,
        requiresVerifiedEmail: true
      }
    },

    {
      path: '/leaderboard',
      name: 'Leaderboard',
      // component: Leaderboard,
      component: DisabledFeature,
      meta: {
        requiresAuth: true,
        requiresVerifiedEmail: true
      }
    },

    {
      path: '/discussion',
      name: 'Discussion',
      component: Discussion,
      meta: {
        requiresAuth: true,
        requiresVerifiedEmail: true
      }
    },

    {
      path: '/rules',
      name: 'Rules',
      component: Rules,
      meta: {
        requiresAuth: false,
        requiresVerifiedEmail: false
      }
    },

    {
      path: '/errors',
      name: 'Errors',
      component: Errors,
      meta: {
        requiresAuth: true,
        requiresVerifiedEmail: false
      }
    },

    {
      path: '/external-resources',
      name: 'ExternalResources',
      component: ExternalResources,
      meta: {
        requiresAuth: false,
        requiresVerifiedEmail: false
      }
    },

    {
      path: '/submissions',
      name: 'Submissions',
      component: Submissions,
      // component: DisabledFeature,
      meta: {
        requiresAuth: true,
        requiresVerifiedEmail: true
      }
    },

    {
      path: '/tour',
      name: 'Tour',
      component: Tour,
      meta: {
        requiresAuth: true,
        requiresVerifiedEmail: true
      }
    },

    {
      path: '/tour1',
      name: 'Tour1',
      component: Tour1,
      meta: {
        requiresAuth: true,
        requiresVerifiedEmail: true
      }
    },
    {
      path: '/tour2',
      name: 'Tour2',
      component: Tour2,
      meta: {
        requiresAuth: true,
        requiresVerifiedEmail: true
      }
    },
    {
      path: '/tour3',
      name: 'Tour3',
      component: Tour3,
      meta: {
        requiresAuth: true,
        requiresVerifiedEmail: true
      }
    },
    {
      path: '/tour4',
      name: 'Tour4',
      component: Tour4,
      meta: {
        requiresAuth: true,
        requiresVerifiedEmail: true
      }
    },
    {
      path: '/tour5',
      name: 'Tour5',
      component: Tour5,
      meta: {
        requiresAuth: true,
        requiresVerifiedEmail: true
      }
    },
    {
      path: '/tour6',
      name: 'Tour6',
      component: Tour6,
      meta: {
        requiresAuth: true,
        requiresVerifiedEmail: true
      }
    },

    {
      path: '/submission-confirmed',
      name: 'SubmissionConfirmed',
      component: SubmissionConfirmed,
      // component: DisabledFeature,
      meta: {
        requiresAuth: true,
        requiresVerifiedEmail: true
      }
    },

    {
      path: '/user-terms',
      name: 'UserTerms',
      component: UserTerms,
      meta: {
        requiresAuth: false,
        requiresVerifiedEmail: false
      }
    },

    {
      path: '/data-terms',
      name: 'DataTerms',
      component: DataTerms,
      meta: {
        requiresAuth: false,
        requiresVerifiedEmail: false
      }
    },

    {
      path: '/submission-terms',
      name: 'SubmissionTerms',
      component: SubmissionTerms,
      meta: {
        requiresAuth: false,
        requiresVerifiedEmail: false
      }
    },

    {
      path: '/final-submission-terms',
      name: 'FinalSubmissionTerms',
      component: FinalSubmissionTerms,
      meta: {
        requiresAuth: false,
        requiresVerifiedEmail: false
      }
    },

    // {
    //   path: '/about-us',
    //   name: 'AboutUs',
    //   component: AboutUs,
    //   meta: {
    //     requiresAuth: false,
    //     requiresVerifiedEmail: false
    //   }
    // },

    {
      path: '/faq',
      name: 'FAQ',
      component: Faq,
      meta: {
        requiresAuth: false,
        requiresVerifiedEmail: false
      }
    },

    {
      path: '/profile',
      name: 'Profile',
      component: Profile,
      meta: {
        requiresAuth: true,
        requiresVerifiedEmail: false
      }
    }
  ]
})
// Navigation guards to protect routes
// to: the target route being navigated to
// from: current route being navigated from
// next: function to resolve the hook (can redirect or abort nav)
router.beforeEach((to, from, next) => {
  // Nav guard for authenticated users
  let currentUser = firebase.auth().currentUser
  let requiresAuth = to.matched.some(record => record.meta.requiresAuth)

  // for secured routes, redirect unauthenticate users to the login view
  if (requiresAuth && !currentUser) next('login')
  // else if (!requiresAuth && currentUser) next('/overview')
  else if (currentUser) next()
  else next()

  // Nav guard to enforce email verification
  let emailVerified = firebase.auth().currentUser.emailVerified  // deprecated; works fine but console log errors are ugly (cannot read property of null)
  let requiresEmailVerified = to.matched.some(record => record.meta.requiresVerifiedEmail)

  // for authenticated routes and users who haven't verified email yet, redirect to the email verification page
  if (requiresAuth && requiresEmailVerified && !emailVerified) next('verify-email')
  else next()
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js